<style>
    .currency-input {
        position: relative;
        display: block;
    }

    .currency-input label {
        font-size: 18px;
        font-weight: 300;
        display: block;
        position: absolute;
        top: 11px;
        left: 8px;
        opacity: 1;
        color: #333333;
        max-width: none;
    }

    .currency-input input {
        padding-left: 18px;
    }
</style>

<template>
    <span class="currency-input">
        <label>$</label>
        <input
        ref="input"
        v-bind:value="value"
        v-bind:class="className"
        v-on:input="updateValue($event.target.value)"
        v-on:focus="selectAll"
        v-on:blur="formatValue"
        >
    </span>
</template>

<script>
    export default {
        props: ['value', 'className'],

        mounted() {
            this.formatValue();
        },

        methods: {
            updateValue(value) {
                var parseValue = (value + '').replace(/[^0-9+\-Ee.]/g, '');
                this.$refs.input.value = Number(parseValue);
                this.$emit('input', Number(parseValue))
            },
            formatValue() {
                this.$refs.input.value = Number(this.value).toLocaleString("en-US", {style: "currency", currency: "USD"}).substring(1);
            },
            selectAll(event) {
                // Workaround for Safari bug
                // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
                setTimeout(function () {
                    event.target.select()
                }, 0)
            }
        }
    }
</script>